var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaluation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7784",
    "data-name": "Group 7784",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.757,
    height: 39,
    viewBox: "0 0 53.757 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M0,2.108A2.108,2.108,0,0,1,2.108,0H51.649a2.108,2.108,0,0,1,2.108,2.108V36.892A2.108,2.108,0,0,1,51.649,39H0Z",
    fill: "#c19444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M7.25,17.219h5.27v2.108H7.25Z",
    transform: "translate(1.183 2.809)",
    fill: "#c5dafa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M31.717,4.531H40.15V6.639H31.717Z",
    transform: "translate(5.175 0.739)",
    fill: "#c5dafa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M23.02,10.778l7-5.158,1.25,1.7-7,5.158Z",
    transform: "translate(3.756 0.917)",
    fill: "#c5dafa"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M14.281,17.231l7.152-5.269,1.25,1.7-7.152,5.269Z",
    transform: "translate(2.33 1.952)",
    fill: "#c5dafa"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M40.779,4.531h2.108V6.639H40.779Z",
    transform: "translate(6.653 0.739)",
    fill: "#c5dafa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M3.625,17.219H5.733v2.108H3.625Z",
    transform: "translate(0.591 2.809)",
    fill: "#c5dafa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M12.687,25.373h6.324v5.27H12.687Z",
    transform: "translate(2.07 4.14)",
    fill: "#ffa100"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M18.124,21.75h6.324v9.486H18.124Z",
    transform: "translate(2.957 3.549)",
    fill: "#ffb401"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M23.562,17.219h6.324V31.976H23.562Z",
    transform: "translate(3.844 2.809)",
    fill: "#ffc431"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M29,12.688h6.324V32.715H29Z",
    transform: "translate(4.731 2.07)",
    fill: "#ffcc4d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M34.436,9.063H40.76V33.306H34.436Z",
    transform: "translate(5.618 1.479)",
    fill: "#ffd873"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M9.968,29H47.914v2.108H9.968Z",
    transform: "translate(1.626 4.732)",
    fill: "#7dafff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M13.889,20.527a2.108,2.108,0,1,0-2.108-2.108A2.108,2.108,0,0,0,13.889,20.527Z",
    transform: "translate(1.922 2.661)",
    fill: "#c5dafa"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M14.037,21.731a3.166,3.166,0,1,1,2.235-.927A3.163,3.163,0,0,1,14.037,21.731Zm0-4.216a1.055,1.055,0,1,0,.745.309A1.054,1.054,0,0,0,14.037,17.514Z",
    transform: "translate(1.774 2.514)",
    fill: "#e0edff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M22.951,14.185a2.108,2.108,0,1,0-2.108-2.108A2.108,2.108,0,0,0,22.951,14.185Z",
    transform: "translate(3.401 1.626)",
    fill: "#c5dafa"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M23.1,15.387a3.166,3.166,0,1,1,2.235-.927A3.161,3.161,0,0,1,23.1,15.387Zm0-4.216a1.055,1.055,0,1,0,.745.309A1.054,1.054,0,0,0,23.1,11.171Z",
    transform: "translate(3.253 1.479)",
    fill: "#e0edff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M31.107,7.841A2.108,2.108,0,1,0,29,5.733,2.108,2.108,0,0,0,31.107,7.841Z",
    transform: "translate(4.731 0.591)",
    fill: "#c5dafa"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M31.254,9.043a3.166,3.166,0,1,1,2.235-.927A3.162,3.162,0,0,1,31.254,9.043Zm0-4.216A1.055,1.055,0,1,0,32,5.136,1.055,1.055,0,0,0,31.254,4.827Z",
    transform: "translate(4.583 0.444)",
    fill: "#e0edff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M2.867,3.92A1.054,1.054,0,1,0,1.813,2.866,1.054,1.054,0,0,0,2.867,3.92Z",
    transform: "translate(0.296 0.296)",
    fill: "#f5714f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M5.585,3.92A1.054,1.054,0,1,0,4.531,2.866,1.054,1.054,0,0,0,5.585,3.92Z",
    transform: "translate(0.739 0.296)",
    fill: "#ffc431"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M8.3,3.92A1.054,1.054,0,1,0,7.25,2.866,1.054,1.054,0,0,0,8.3,3.92Z",
    transform: "translate(1.183 0.296)",
    fill: "#3cde8d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluation);
export default __webpack_public_path__ + "static/media/evaluation.05bdf9825ef7cde8f2c2db020858aa49.svg";
export { ForwardRef as ReactComponent };